/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import { useSfetchMutator } from '../sfetchMutator';


export type gogglesInfoResponse200 = {
  data: void
  status: 200
}

export type gogglesInfoResponseSuccess = (gogglesInfoResponse200) & {
  headers: Headers;
};
;

export type gogglesInfoResponse = (gogglesInfoResponseSuccess)

export const getGogglesInfoUrl = () => {




  return `/api/goggles/info`
}

export const useGogglesInfoHook = (): ( options?: RequestInit) => Promise<gogglesInfoResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getGogglesInfoUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type gogglesDownloadResponse200 = {
  data: void
  status: 200
}

export type gogglesDownloadResponseSuccess = (gogglesDownloadResponse200) & {
  headers: Headers;
};
;

export type gogglesDownloadResponse = (gogglesDownloadResponseSuccess)

export const getGogglesDownloadUrl = () => {




  return `/api/goggles/download`
}

export const useGogglesDownloadHook = (): ( options?: RequestInit) => Promise<gogglesDownloadResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getGogglesDownloadUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


